import { render, staticRenderFns } from "./HistoricalRepaired.vue?vue&type=template&id=518ce0a2&lang=pug"
import script from "./HistoricalRepaired.vue?vue&type=script&lang=js"
export * from "./HistoricalRepaired.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports